import type { MinimalRailShell } from "~/components/dock/minimalRailShell";

import { ApplicationEnum } from "~/@types/enums";
import buildMinimalRailShell from "~/components/dock/minimalRailShell";
import { resolveNavSlotPath } from "~/components/mobile/bottomNav/mobileBottomNav";
import { type TranslateKey, translateWithActiveLanguage } from "~/helpers/localizedText";

const buildAvailabilityRail = (
	basePath: string,
	canRecordShrink: boolean,
	translate: TranslateKey = translateWithActiveLanguage
): MinimalRailShell =>
	buildMinimalRailShell(
		ApplicationEnum.AVAILABILITY,
		[
			{
				icon: "inventory_2",
				id: "inventory",
				path: resolveNavSlotPath(basePath, ""),
				title: translate("mobile:availability.rail.inventory")
			},
			{
				icon: "checklist",
				id: "count",
				path: resolveNavSlotPath(basePath, "count"),
				title: translate("mobile:availability.rail.count")
			},
			...(canRecordShrink
				? [
						{
							icon: "trending_down",
							id: "shrink",
							path: resolveNavSlotPath(basePath, "shrink"),
							title: translate("mobile:availability.rail.shrink")
						}
					]
				: []),
			{
				icon: "history",
				id: "history",
				path: resolveNavSlotPath(basePath, "history"),
				title: translate("mobile:availability.rail.history")
			}
		],
		"aod"
	);

export default buildAvailabilityRail;
